export enum MpAccordionType {
    FAQ = 'FAQ',
}
